import React from "react";
import styles from './Spinner.module.css';

const Spinner = props => {

    const {remark} = props;

    return (
        <div className={styles.container}>
            <span className={styles.wrapper}>
                <div className={styles.spinner} />
                {!!remark && <p className={styles.remark}>{remark}</p>}
            </span>
        </div>
    )
}

export default Spinner;